"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createIcon_1 = __importDefault(require("../createIcon"));
var BrandIconTime = function (props) {
    return (react_1.default.createElement(createIcon_1.default, __assign({ role: "img", ariaLabel: "Time" }, props),
        react_1.default.createElement("title", null, "Time"),
        react_1.default.createElement("path", { d: "M65.242 36.002V14.285H53.81v21.717h11.432zM107.297 40.83L93.016 26.55 81.273 38.291l14.28 14.281 11.744-11.743zM23.529 52.578l14.28-14.281-11.742-11.743-14.281 14.28 11.743 11.744z", fill: "#007562" }),
        react_1.default.createElement("path", { d: "M59.52 111.429c23.669 0 42.857-19.188 42.857-42.858 0-23.669-19.188-42.857-42.857-42.857-23.67 0-42.858 19.188-42.858 42.858 0 23.669 19.188 42.857 42.858 42.857z", fill: "#FF6E00" }),
        react_1.default.createElement("path", { d: "M59.52 111.429c-23.668 0-42.858-19.19-42.858-42.858 0-23.667 19.19-42.857 42.858-42.857", fill: "#D44513" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M55.234 40.575h8.571V66.15l18.038 18.128-6.076 6.046-20.533-20.636V40.575z", fill: "#000" }),
        react_1.default.createElement("path", { d: "M76.662 8.572H42.377v11.432h34.285V8.572z", fill: "#007562" })));
};
exports.default = BrandIconTime;
